import {
  actions,
  getFaqByIdAsync,
  getFaqCtegoriesAsync,
  getFaqsDataTableAsync,
  createNewCategoryAsync,
  createNewFaqAsync,
  deleteFaqAsync,
  deleteCategoryAsync,
  editCategoryAsync,
  editFaqAsync,
  getCategoryFaqsAsync,
  createFaqEngagementAsync,
} from './slices';

export const FAQsActions = {
  ...actions,
  getFaqByIdAsync,
  getFaqCtegoriesAsync,
  getFaqsDataTableAsync,
  createNewCategoryAsync,
  createNewFaqAsync,
  deleteFaqAsync,
  deleteCategoryAsync,
  editCategoryAsync,
  editFaqAsync,
  getCategoryFaqsAsync,
  createFaqEngagementAsync,
};
